import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FormCheckbox } from '@fs/zion-form'
import { Row, Cell } from '@fs/zion-ui'
import { getNestedSubelementsByType, getMostRecentFieldValue, getPersonName } from '@fs/zion-sls'
import { useR2StateContext } from '../../../../../../providers/r2Provider/R2Context'

const getPersonGivenName = (person) => {
  const foundGiven = getNestedSubelementsByType(person, 'NAME_GN')
  const givenName = getMostRecentFieldValue(foundGiven?.[0]) || ''
  return givenName
}

const SharedFieldPersonsCheckboxes = ({ personsSharingFieldOnImage, linkedFieldValue, isNewPerson, setValue }) => {
  const [t] = useTranslation()
  const r2State = useR2StateContext()
  const newPerson = t('add-highlight-linked-fields.new-person', 'New person')
  const noRelationship = t('add-highlight-linked-fields.no-relationship', 'No relationship')

  useEffect(() => {
    personsSharingFieldOnImage.forEach((person) => {
      setValue(person.id, true)
    })
  }, [personsSharingFieldOnImage, setValue])

  return (
    <Row gutters="sm" guttersY="none" wrap alignX="start" alignY="bottom">
      {personsSharingFieldOnImage?.map((person) => {
        const isSelectedPerson = r2State.selectedPersonId === person.id
        const personFullName =
          isSelectedPerson && r2State.highlightsFieldInfo.fieldType === 'NAME_SURN'
            ? `${getPersonGivenName(person)} ${linkedFieldValue}`
            : getPersonName({ person })
        const relationshipToHead = getNestedSubelementsByType(person, 'RELATIONSHIP_TO_HEAD')?.[0]
        let relationshipToHeadValue = getMostRecentFieldValue(relationshipToHead)
        if (!relationshipToHeadValue)
          relationshipToHeadValue = isNewPerson && isSelectedPerson ? newPerson : noRelationship

        const relationshipSuffix = relationshipToHeadValue ? ` (${relationshipToHeadValue})` : ''

        return (
          <Cell
            key={person.id}
            style={{
              width: '300px',
              paddingInlineStart: '10px',
              paddingTop: '10px',
            }}
          >
            <FormCheckbox
              disabled
              checked
              name={person.id}
              value={person.id}
              label={`${personFullName}${relationshipSuffix}`}
            />
          </Cell>
        )
      })}
    </Row>
  )
}

export default SharedFieldPersonsCheckboxes
